import * as types from './constants';

const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_NAME: {
      return {
        ...state,
        user: {
          ...state.user,
          username: payload,
        },
      };
    }
    case types.SET_USER_ID: {
      return {
        ...state,
        user: {
          ...state.user,
          userId: payload,
        },
      };
    }
    case types.SET_RESULT: {
      return {
        ...state,
        user: {
          ...state.user,
          result: payload,
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;